import type { PublicCatalogProduct } from "@/domain/catalog/catalog-product";

export function formatProductType(type: PublicCatalogProduct["type"]): string {
  return type === "generico" ? "Genérico" : "Original";
}
